
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import api from '../../api/api'
import axios from 'axios';
import { api_url } from '../../utils/utils'
// ============================================
// ASYNC THUNKS
// ============================================

// ✅ Ana səhifə bannerlərini çək (hamısı birlikdə)
export const get_banners = createAsyncThunk(
    'banner/get_banners',
    async (_, { fulfillWithValue, rejectWithValue,getState }) => {
            // const token = getState().auth.token || localStorage.getItem('accessToken');
            // const config = {
            //     headers: { 'Authorization': `Bearer ${token}` }
            // };
        try {
            const { data } = await axios.get(`${api_url}/api/banners`, {withCredentials: true})
            return fulfillWithValue(data)
        } catch (error) {
            return rejectWithValue(error.response?.data || error.response)
        }
    }
)

// ✅ Banner qiymətlərini çək
export const get_banner_prices = createAsyncThunk(
    'banner/get_banner_prices',
    async (_, { fulfillWithValue, rejectWithValue, getState }) => {
        // const token = getState().auth.token || localStorage.getItem('accessToken');
        // const config = {
        //     headers: { 'Authorization': `Bearer ${token}` }
        // };
        try {
            const { data } = await axios.get(`${api_url}/api/banner-prices`, {withCredentials: true})
            return fulfillWithValue(data)
        } catch (error) {
            return rejectWithValue(error.response?.data || error.response)
        }
    }
)

// ✅ Admin - ana banner əlavə et
export const add_banner = createAsyncThunk(
    'banner/add_banner',
    async (formData, { fulfillWithValue, rejectWithValue, getState }) => {
        // const token = getState().auth.token || localStorage.getItem('accessToken');
        // const config = {
        //     headers: { 'Authorization': `Bearer ${token}` }
        // };
        try {
            const { data } = await api.post(`/banner/add`, formData, {withCredentials: true})
            return fulfillWithValue(data)
        } catch (error) {
            return rejectWithValue(error.response?.data || error.response)
        }
    }
)

// ✅ Admin - banneri yenilə
export const update_banner = createAsyncThunk(
    'banner/update_banner',
    async ({ info, bannerId }, { fulfillWithValue, rejectWithValue, getState }) => {
        // const token = getState().auth.token || localStorage.getItem('accessToken');
        // const config = {
        //     headers: { 'Authorization': `Bearer ${token}` }
        // };
        try {
            const { data } = await api.put(`/banner/update/${bannerId}`, info, {withCredentials: true})
            return fulfillWithValue(data)
        } catch (error) {
            return rejectWithValue(error.response?.data || error.response)
        }
    }
)

// ✅ Admin - banneri sil
export const delete_banner = createAsyncThunk(
    'banner/delete_banner',
    async (bannerId, { fulfillWithValue, rejectWithValue, getState }) => {
        // const token = getState().auth.token || localStorage.getItem('accessToken');
        // const config = {
        //     headers: { 'Authorization': `Bearer ${token}` }
        // };
        try {
            const { data } = await api.delete(`/banner/delete/${bannerId}`, {withCredentials: true})
            return fulfillWithValue({ ...data, bannerId })
        } catch (error) {
            return rejectWithValue(error.response?.data || error.response)
        }
    }
)

// ✅ Seller - ödənişli banner əlavə et
export const add_seller_banner = createAsyncThunk(
    'banner/add_seller_banner',
    async (formData, { fulfillWithValue, rejectWithValue, getState }) => {
        // const token = getState().auth.token || localStorage.getItem('accessToken');
        // const config = {
        //     headers: { 'Authorization': `Bearer ${token}` }
        // };
        try {
            const { data } = await api.post(`/seller-banner/add`, formData, {withCredentials: true})
            return fulfillWithValue(data)
        } catch (error) {
            return rejectWithValue(error.response?.data || error.response)
        }
    }
)

// ✅ Seller - banneri ləğv et
export const cancel_seller_banner = createAsyncThunk(
    'banner/cancel_seller_banner',
    async (bannerId, { fulfillWithValue, rejectWithValue, getState }) => {
        // const token = getState().auth.token || localStorage.getItem('accessToken');
        // const config = {
        //     headers: { 'Authorization': `Bearer ${token}` }
        // };
        try {
            const { data } = await api.post(`/seller-banner/cancel`, { bannerId }, {withCredentials: true})
            return fulfillWithValue(data)
        } catch (error) {
            return rejectWithValue(error.response?.data || error.response)
        }
    }
)

// ✅ Seller - öz bannerlərini gör
export const get_seller_banners = createAsyncThunk(
    'banner/get_seller_banners',
    async ({ page = 1, limit = 10, status } = {}, { fulfillWithValue, rejectWithValue, getState }) => {
        // const token = getState().auth.token || localStorage.getItem('accessToken');
        // const config = {
        //     headers: { 'Authorization': `Bearer ${token}` }
        // };
        try {
            const query = `page=${page}&limit=${limit}${status ? `&status=${status}` : ''}`
            const { data } = await axios.get(`${api_url}/api/seller-banners?${query}`, {withCredentials: true})
            return fulfillWithValue(data)
        } catch (error) {
            return rejectWithValue(error.response?.data || error.response)
        }
    }
)

// ============================================
// SLICE
// ============================================
export const bannerReducer = createSlice({
    name: 'banner',
    initialState: {
        loader: false,
        successMessage: '',
        errorMessage: '',

        // Ana səhifə bannerlər
        mainBanners: [],          // Sol böyük slider (admin)
        topSellerBanners: [],     // Sağ yuxarı (seller ödənişli)
        bottomSellerBanners: [],  // Sağ aşağı (seller ödənişli)
        banners: [],              // Köhnə kod uyğunluğu üçün

        // Seller öz bannerleri
        sellerBanners: [],
        totalBanners: 0,
        currentPage: 1,
        totalPages: 1,

        // Admin panel
        banner: null,

        // Qiymətlər
        bannerPrices: null,

        // Wallet
        remainingBalance: 0
    },

    reducers: {
        messageClear: (state) => {
            state.successMessage = ''
            state.errorMessage = ''
        }
    },

    extraReducers: (builder) => {
        builder

            // ── get_banners ──────────────────────────────
            .addCase(get_banners.pending, (state) => {
                state.loader = true
            })
            .addCase(get_banners.fulfilled, (state, { payload }) => {
                state.loader = false
                state.mainBanners = payload.mainBanners || []
                state.topSellerBanners = payload.topSellerBanners || []
                state.bottomSellerBanners = payload.bottomSellerBanners || []
                state.banners = payload.banners || []  // Köhnə kod uyğunluğu
            })
            .addCase(get_banners.rejected, (state) => {
                state.loader = false
            })

            // ── get_banner_prices ────────────────────────
            .addCase(get_banner_prices.fulfilled, (state, { payload }) => {
                state.bannerPrices = payload.prices
            })

            // ── add_banner (admin) ───────────────────────
            .addCase(add_banner.pending, (state) => {
                state.loader = true
            })
            .addCase(add_banner.fulfilled, (state, { payload }) => {
                state.loader = false
                state.successMessage = payload.message
                if (payload.banner) {
                    state.mainBanners.unshift(payload.banner)
                }
            })
            .addCase(add_banner.rejected, (state, { payload }) => {
                state.loader = false
                state.errorMessage = payload?.message || 'Xəta baş verdi'
            })

            // ── update_banner ────────────────────────────
            .addCase(update_banner.pending, (state) => {
                state.loader = true
            })
            .addCase(update_banner.fulfilled, (state, { payload }) => {
                state.loader = false
                state.successMessage = payload.message
                state.banner = payload.banner
            })
            .addCase(update_banner.rejected, (state, { payload }) => {
                state.loader = false
                state.errorMessage = payload?.message || 'Xəta baş verdi'
            })

            // ── delete_banner ────────────────────────────
            .addCase(delete_banner.fulfilled, (state, { payload }) => {
                state.successMessage = payload.message
                state.mainBanners = state.mainBanners.filter(b => b._id !== payload.bannerId)
            })

            // ── add_seller_banner ────────────────────────
            .addCase(add_seller_banner.pending, (state) => {
                state.loader = true
            })
            .addCase(add_seller_banner.fulfilled, (state, { payload }) => {
                state.loader = false
                state.successMessage = payload.message
                state.remainingBalance = payload.remainingBalance
                if (payload.banner) {
                    state.sellerBanners.unshift(payload.banner)
                }
            })
            .addCase(add_seller_banner.rejected, (state, { payload }) => {
                state.loader = false
                state.errorMessage = payload?.message || 'Xəta baş verdi'
            })

            // ── cancel_seller_banner ─────────────────────
            .addCase(cancel_seller_banner.pending, (state) => {
                state.loader = true
            })
            .addCase(cancel_seller_banner.fulfilled, (state, { payload }) => {
                state.loader = false
                state.successMessage = payload.message
                state.remainingBalance = payload.remainingBalance
            })
            .addCase(cancel_seller_banner.rejected, (state, { payload }) => {
                state.loader = false
                state.errorMessage = payload?.message || 'Xəta baş verdi'
            })

            // ── get_seller_banners ───────────────────────
            .addCase(get_seller_banners.pending, (state) => {
                state.loader = true
            })
            .addCase(get_seller_banners.fulfilled, (state, { payload }) => {
                state.loader = false
                state.sellerBanners = payload.banners
                state.totalBanners = payload.total
                state.currentPage = payload.page
                state.totalPages = payload.pages
            })
            .addCase(get_seller_banners.rejected, (state) => {
                state.loader = false
            })
    }
})

export const { messageClear } = bannerReducer.actions
export default bannerReducer.reducer